import { DashedTitle, Icon } from '@fasstech/middle-design-system';

const ClosedComponent = ({ children, titleLabel, icon }) => {
  return (
    <div className="flex flex-col gap-2 p-4">
      <div className="flex flex-col items-center gap-2">
        <Icon name={icon} size={20} />
        <DashedTitle>{titleLabel}</DashedTitle>
      </div>
      {children}
    </div>
  );
};

export default ClosedComponent;
